import { render, staticRenderFns } from "./DeliveryAddressDiscount.vue?vue&type=template&id=5f9c1900"
import script from "./DeliveryAddressDiscount.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports